import cn from 'clsx';
import type {ReactNode} from 'react';

import RichText from '@/components/RichText/RichText';

export interface TipCardProps {
    icon: ReactNode;
    title?: string;
    description?: string;
    titleSizeClass?: string;
    btnText?: string;
}

const TipCard = ({icon, title, description, titleSizeClass = 'text-14', btnText}: TipCardProps) => (
    <div className='flex w-full items-center gap-2'>
        {icon}
        <div className='flex w-full flex-col text-left text-primary dark:text-romance'>
            {/* The card is a button when actionable, and a button cannot hold a heading. */}
            <RichText
                as='span'
                html={title}
                className={cn('font-bold text-primary dark:text-romance', titleSizeClass)}
            />
            <RichText html={description} className='text-14 text-primary leading-5 dark:text-romance' />
            {/* Affordance only - the card around it carries the click. */}
            {btnText && <span className='mt-2 self-start text-14 underline'>{btnText}</span>}
        </div>
    </div>
);

export default TipCard;
